import { createContext } from "react";
import contextType from "./contextType";

export const Context = createContext<contextType>(undefined!);